import { afterEveryRender, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, signal, ViewChild, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectDrawingFeatures, selectSelectedDrawingFeature, updateDrawingFeatureStyle } from '../state';
import { combineLatest, map, Observable } from 'rxjs';
import { DrawingFeatureModel } from '../../../map/models/drawing-feature.model';
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription } from '@angular/material/expansion';
import { DrawingStyleIconComponent } from '../../../map/components/drawing-style-icon/drawing-style-icon.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'tm-drawing-objects-list',
    templateUrl: './drawing-objects-list.component.html',
    styleUrls: ['./drawing-objects-list.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        MatExpansionPanelDescription,
        DrawingStyleIconComponent,
        AsyncPipe,
    ],
})
export class DrawingObjectsListComponent {
  private store$ = inject(Store);
  private elRef = inject(ElementRef);

  @Input()
  public drawingLayerId = '';

  @Output()
  public featureSelected = new EventEmitter<string>();

  @ViewChild('editDescription')
  private editDescription: ElementRef | null = null;

  public features$: Observable<Array<DrawingFeatureModel & { selected: boolean }>> = combineLatest([
    this.store$.select(selectDrawingFeatures),
    this.store$.select(selectSelectedDrawingFeature),
  ]).pipe(map(([ features, selectedFeature ]) => {
    this.selectedFeature = selectedFeature?.__fid ?? null;
    return features.map(f => ({ ...f, selected: f.__fid === selectedFeature?.__fid }));
  }));

  public editingDescriptionForFeatureFid: string | null = null;
  private selectedFeature: string | null = null;
  public isExpanded = signal<boolean>(false);

  constructor() {
    afterEveryRender(() => {
      this.scrollToSelectedFeature();
    });
  }

  public selectFeature(fid: string) {
    this.featureSelected.emit(fid);
  }

  public stripMacros(description: string | undefined) {
    return (description || '').replace(/\[[A-Z]+]/g, '');
  }

  public selectFeatureAndEditDescription(fid: string) {
    this.selectFeature(fid);
    this.editingDescriptionForFeatureFid = fid;
    setTimeout(() => {
      this.editDescription?.nativeElement.focus();
    }, 0);
  }

  public updateDescription() {
    if (!this.editingDescriptionForFeatureFid || !this.editDescription) {
      return;
    }
    this.store$.dispatch(updateDrawingFeatureStyle({ fid: this.editingDescriptionForFeatureFid, style: { description: this.editDescription.nativeElement.value } }));
    this.editingDescriptionForFeatureFid = null;
  }

  public cancelDescriptionEdit() {
    this.editingDescriptionForFeatureFid = null;
  }

  private srcolledToFeature: string | null = null;

  private scrollToSelectedFeature() {
    if (!this.isExpanded() || !this.selectedFeature || !this.elRef || !this.elRef.nativeElement || this.srcolledToFeature === this.selectedFeature) {
      return;
    }
    this.srcolledToFeature = this.selectedFeature;
    this.elRef.nativeElement.querySelector(`[data-feature-fid="${this.selectedFeature}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

}
